export default [
    {
        dictKey: "",
        dictValue: "全部",
    },
    {
        dictKey: "3",
        dictValue: "购买账户",
    },
    {
        dictKey: "1",
        dictValue: "分润账户",
    },
    {
        dictKey: "2",
        dictValue: "其他账户",
    },
    {
        dictKey: "6",
        dictValue: "活动账户",
    },
    {
        dictKey: "7",
        dictValue: "个人账户",
    },
    {
        dictKey: "9",
        dictValue: "商户账户",
    },
    {
        dictKey: "8",
        dictValue: "生态账户",
    },
    {
        dictKey: "10",
        dictValue: "收单欢乐豆",
    },
    {
        dictKey: "11",
        dictValue: "收单积分",
    },
    {
        dictKey: "12",
        dictValue: "真商账户",
    }
];



// WEBPACK FOOTER //
// ./src/service/constant/LYFAcctTypes.js